import React from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import Typography from '../Typography/Typography';
import { Type } from '../../base/Type/Type';
import { NewsItemStoryblok } from '../../types/storyblok';
import { Box } from '../../base/Box/Box';
import Link from '../../base/Link/Link';
import { getImage, GatsbyImage } from 'gatsby-plugin-image';

dayjs.extend(relativeTime);

const getTargetImage = (cardImage: any) =>
  getImage(cardImage?.images?.slice(-1)[0]);

const NewsArticleCard = ({
  category,
  datePublished,
  link,
  publisherName,
  title,
  cardImage,
}: NewsItemStoryblok) => {
  const targetImage = getTargetImage(cardImage);

  return (
    <Box as="div" className="flex flex-col w-[370px]">
      <Box as="span" className="bg-ffDarkGrey w-full h-[328px] rounded-md">
        <GatsbyImage image={targetImage} objectFit="fill" alt={title} />
      </Box>
      <Box as="div" className="mt-3">
        <Link
          href={link}
          className="font-foundersGrotesk text-2xl mb-4 hover:opacity-80"
        >
          {title}
        </Link>
      </Box>
      <Typography
        alignItems="center"
        component="time"
        dateTime={datePublished}
        display="flex"
        variant="body-small"
        className="font-foundersGrotesk opacity-60 !mt-4"
      >
        {dayjs(datePublished).fromNow()}
      </Typography>
      <Box as="div" className="flex mt-2">
        <Type
          as="p"
          className="bg-ffYellow font-foundersGrotesk rounded-lg py-2 px-4 capitalize"
        >
          {publisherName ?? category}
        </Type>
      </Box>
    </Box>
  );
};

export default NewsArticleCard;
